import { firestore } from '../configs/firebase';
import {
  collection,
  getDocs,
  orderBy,
  OrderByDirection,
  query,
  where,
} from 'firebase/firestore';
import { FirestoreCollections } from '@leedpulse-monorepo/firebase-metadata';
import { normalizeUser } from '@leedpulse-monorepo/utils';
import { IUser } from '@leedpulse-monorepo/interfaces';

export interface Constraint {
  op:
    | '=='
    | '!='
    | '>='
    | '<='
    | '<'
    | '>'
    | 'in'
    | 'not-in'
    | 'array-contains'
    | 'array-contains-any'
    | 'orderBy';
  field: string;
  value: string | number | boolean | string[] | number[] | boolean[];
}

export const getUsersByConstraints = async (constraints: Constraint[] = [], subscriptionId: string) => {
  try {
    const usersRef = collection(firestore, FirestoreCollections.users);

    const queryConstraints = constraints.map((constraint) => {
      if(constraint.op === 'orderBy') {
        return orderBy(constraint.field, constraint.value as OrderByDirection);
      }
      return where(constraint.field, constraint.op, constraint.value);
    });

    const q = query(usersRef, ...queryConstraints);
    const querySnapshot = await getDocs(q);

    if (!querySnapshot.empty) {
      const users = querySnapshot.docs.map((doc) => {
        return normalizeUser(doc.data() as IUser, subscriptionId);
      });
      return {
        success: true,
        status: 'success',
        msg: 'Utilisateurs récupérés avec succès.',
        doc: users,
      };
    } else {
      return {
        success: false,
        status: 'error',
        msg: 'Utilisateurs non trouvés',
      };
    }
  } catch (error: any) {
    return {
      success: false,
      status: 'error',
      msg: error.message.toLocaleString(),
    };
  }
}

export default {
  getUsersByConstraints,
};